import { render } from "./SystemTitle.vue?vue&type=template&id=7fe3cca2"
import script from "./SystemTitle.vue?vue&type=script&lang=js"
export * from "./SystemTitle.vue?vue&type=script&lang=js"
script.render = render

export default script